/**
 * Formateo de la dirección de una recogida
 */

/**
 * Compone la dirección en una línea a partir del objeto anidado que devuelve la API.
 * La API nunca envía un campo plano `direccionCompleta`: solo
 * `direccion.{nombre,direccion,codigoPostal,poblacion,provincia}`.
 * @param {Object} direccion - Objeto direccion de la recogida
 * @returns {string} "Nombre - Dirección, CP Población, Provincia" o cadena vacía
 */
export const formatearDireccion = (direccion) => {
    if (!direccion) {
        return '';
    }

    const nombre = direccion.nombre || '';
    const via = direccion.direccion || '';
    const cp = direccion.codigoPostal || '';
    const poblacion = direccion.poblacion || '';
    const provincia = direccion.provincia || '';

    const resto = `${via}, ${cp} ${poblacion}, ${provincia}`;

    return nombre ? `${nombre} - ${resto}` : resto;
};
